/**
 * Copyright © 2017, Rezo Zero
 *
 * @file DefaultPage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import Page from './Page'
import { $window } from '../utils/environment'

/**
 * Default Page.
 *
 * @extends {Page}
 * @private
 */
export default class DefaultPage extends Page {
    init () {
        super.init()

        this.previousPage = window.previousPage
        window.previousPage = 'default'

        $window.triggerHandler('background.white')
        $window.triggerHandler('bubble.resetOpacity')
    }

    onLazyImageProcessed (index) {}

    onResize () {}

    onLazyImageSet (element) {}

    onLazyImageLoad (element) {}
}



// WEBPACK FOOTER //
// ./webpack/js/pages/DefaultPage.js